export default "__VITE_ASSET__BUE1dXTg__"